import { createContext } from "react";

export interface ThemeContextValue {
  logoUrl: string | null;
  logoDarkUrl: string | null;
  legalName: string | null;
  isLoading: boolean;
}

export const ThemeContext = createContext<ThemeContextValue>({
  logoUrl: null,
  logoDarkUrl: null,
  legalName: null,
  isLoading: false,
});
